var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c("InfoBox", [
        _vm._v(
          '\n\t\tDiese Nachricht dient zur Info und setzt keinen Folgeschritt voraus. Markiere sie als gelesen, damit\n\t\tsie nicht mehr unter "Neue Nachrichten" angezeigt wird.\n\t'
        )
      ]),
      _vm._v(" "),
      _c("Button", {
        staticClass: "mt-3",
        attrs: {
          text: "Als gelesen markieren",
          disabled: _vm.sendingRequest,
          loading: _vm.sendingRequest
        },
        on: { click: _vm.markAsRead }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }